import Link from 'next/link';
import AlphabetList from './alphabet-list';
import { useMemo } from 'react';
import { Paragraph, Wrap } from '@leafwell/components';
import { groupItemsByTitleFirstLetter } from 'lib/utils/groupItemsByTitleFirstLetter';

export type AlphabeticalGridItem = {
  slug: string;
  title: string;
  link: string;
};

type AlphabeticalGridListProps = {
  exploreLabel?: string;
  showNumbersFilter?: boolean;
  className?: string;
  data: AlphabeticalGridItem[];
  onChangeLetter?(letter: string): void;
};

const AlphabeticalGridList = ({
  data = [],
  showNumbersFilter,
  exploreLabel,
  className,
  onChangeLetter,
}: AlphabeticalGridListProps) => {
  const groupedItems = useMemo(
    () => groupItemsByTitleFirstLetter(data),
    [data],
  );

  return (
    <Wrap className={['!gap-y-1', className].join(' ')}>
      {exploreLabel && (
        <Paragraph className="mb-4" {...{ size: 'xsmall' }}>
          {exploreLabel}
        </Paragraph>
      )}
      <div className="sticky top-[130px] md:top-[68px] xl:top-[100px] z-1 overflow-hidden">
        <AlphabetList
          useHash
          letterNumbers={Object.keys(groupedItems).filter(Number)}
          showNumbersFilter={showNumbersFilter}
          onChangeLetter={onChangeLetter}
        />
      </div>
      {Object.keys(groupedItems).map(key => {
        return (
          <div
            id={key.toLowerCase()}
            key={key}
            className="pb-6 [&:not(:last-child)]:border-b-[1px] scroll-mt-[220px] md:scroll-mt-[190px] "
          >
            <h3 className="text-2xl mt-4 font-medium">{key}</h3>
            <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-4">
              {groupedItems[key].map(item => (
                <li key={item.slug} className="rounded-md">
                  <Link
                    href={item.link}
                    prefetch={false}
                    className="hover:text-lilac-500"
                  >
                    {item.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        );
      })}
    </Wrap>
  );
};

export default AlphabeticalGridList;
